export const DASHBOARD_LOGIN_URL = 'https://dashboard.stripe.com/';
export const DASHBOARD_EXPRESS_URL = 'https://dashboard.stripe.com/express';
